import { useCallback } from 'react';
import { sdk } from 'sdk';

const useAmazonPay = () => {
  const getAmazonCheckoutSessionData = useCallback(async (amazonCheckoutSessionId: string) => {
    const payload = {
      amazonCheckoutSessionId,
    };
    const response = await sdk.callAction({
      actionName: 'amazon/getAmazonCheckoutSession',
      payload: payload,
    });

    return response.isError ? { Result: -1, ErrorText: 'service-error' } : response.data;
  }, []);

  return { getAmazonCheckoutSessionData };
};

export default useAmazonPay;
